import {ILoginService} from './login.service';
import {
    State,
    StateDeclaration,
    Transition,
    TransitionStateHookFn,
    HookResult
} from 'angular-ui-router';

export namespace AuthGuard {
  export const REQUIRES_AUTH_KEY = 'requiresAuth';
  export const configureEnterGuard = ($transitions: Transition) => {
    const onEnterGuard: TransitionStateHookFn =
        (transition: Transition, state: State): HookResult => {
          const toState: StateDeclaration = transition.to();
          const loginService = transition.injector()
              .get('loginService');
          if (toState.data && toState.data[REQUIRES_AUTH_KEY]) {
            if (!loginService.isLoggedIn()) {
              return transition.router
                  .stateService.target('login', {}, {location: 'replace'});
            }
          }
          return true;
        };
    $transitions.onEnter({}, onEnterGuard);
  };
  configureEnterGuard.$inject = ['$transitions'];
}



/** WEBPACK FOOTER **
 ** ./app/auth/auth-guard.ts
 **/